// --------------------------------------------------------
// AGENDAS PROFISSIONAL - AgendasProfissional
// --------------------------------------------------------

// --------------------------------------------------------
// IMPORTS
// --------------------------------------------------------
import React, { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch } from '../..';
import AgendaMesListItem from '../../components/criarAgenda/AgendaMesListItem';
import CriarAgendaHeader from '../../components/criarAgendaHeader/CriarAgendaHeader';
import ListHeader from '../../components/itemList/ListHeaders';
import ContainerWithSidebar from '../../components/UI/containerWithSidebar/ContainerWithSidebar';
import { TextLink, Text, TableData } from '../../components/UI/generalLayout/Layout.styled';
import Colors from '../../constants/Colors';
import useResponsiveInfo from '../../hooks/useResponsiveInfo';
import { GeneralContainer } from '../home/Home.styled';
import * as agendasActions from '../../store/actions/agenda';
import { useSelector } from 'react-redux';
import Agenda from '../../models/core/agenda/Agenda';
import moment from 'moment';
import { Paths } from '../../enums/Paths';
import { CircularProgress, Table } from '@mui/material';
import AgendaMes from '../../models/core/agenda/AgendaMes';
import { CompanyListContainer } from '../company/CompanyList.styled';

// --------------------------------------------------------
// AGENDAS PROFISSIONAL INTERFACE
// --------------------------------------------------------
/**
 * A component that renders a Screen.
 *
 * @param props Properties
 * @param props.route The route
 * @param props.navigation The navigator
 * @returns The component JSX.
 */
function AgendasProfissional(): JSX.Element {
  // --------------------------------------------------------
  // AGENDAS PROFISSIONAL PRIVATE DECLARATIONS
  // --------------------------------------------------------
  const { isMobile } = useResponsiveInfo()
  const [isLoading, setIsLoading] = useState(true)
  const { state }: any = useLocation();
  const { nome, agenda } = state;
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const agendasProfissional: AgendaMes[] = useSelector((state: any) => state.agenda.agendasProfissional)

  const fetchAgendasProfissional = useCallback(async () => {
    setIsLoading(true)
    await dispatch(agendasActions.fetchAgendasProfissional(agenda.id, agenda.perfilSaude))
    setIsLoading(false)
  }, [agenda])

  useEffect(() => {
    fetchAgendasProfissional();
  }, [agenda])


  const activateOrInactivateAgenda = async (agendas: any, isActive: boolean) => {
    await dispatch(agendasActions.activateOrDeactivateAgendaMes(agendas, agenda, isActive))
    // fetchAgendasProfissional();
  }

  return <ContainerWithSidebar>
    <GeneralContainer>
      <TextLink color={Colors.SPM600} onClick={() => { navigate(Paths.AgendaList) }}>{'< Voltar para a listagem de profissionais'}</TextLink>
      <CriarAgendaHeader nome={nome} agenda={agenda} />
      <div>
        {isLoading ? (<div style={{ textAlign: 'center', marginTop: 50, overflow: 'hidden' }}>
          <CircularProgress />
        </div>) : (<>
          {agendasProfissional.length > 0 ? (<div>
            {!isMobile && (<Table>
              <TableData width={'20%'} style={{ verticalAlign: 'middle' }}>
                  <Text bold>Mês</Text>
              </TableData>
              <TableData width={'25%'} style={{ verticalAlign: 'middle' }}>
                  <Text bold>Unidades</Text>
              </TableData>
              <TableData width={'20%'} style={{ verticalAlign: 'middle', textAlign:'right' }}>
                  <Text bold>Ativar/Desativar</Text>
              </TableData>
            </Table>)}
            <CompanyListContainer>
              {agendasProfissional.map((agendaProfissional: any, index: number) => {
                return <AgendaMesListItem
                  key={index}
                  profissionalInfo={agenda}
                  agenda={agendaProfissional}
                  mes={{ mes: agendaProfissional.mes, mesDescricao: agendaProfissional.mesDescricao, ano: String(moment(agendaProfissional.data).year()) }}
                  nomeProfissional={nome}
                  onActivateInactivate={() => { activateOrInactivateAgenda(agendaProfissional, agendaProfissional.inativo) }}
                />
              })}
            </CompanyListContainer>

          </div>) : (<Text>Nenhum resultado encontrado</Text>)}</>)}
      </div>
    </GeneralContainer>
  </ContainerWithSidebar>;
}

export default AgendasProfissional;
